<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="loaded">
  <div class="container-fluid ">
    <div class="row">
      <div class="col-12">
        <span class="m-xst float-right m-l-md leyenda"> {{ 'General.search.showing' | translate }} {{ validations ?
          validations.length : '0' }}</span>
      </div>
    </div>
    <div class="row filterHeader">
      <div class="col-6">
        <p-dropdown [options]="types" [(ngModel)]="selectedType" (onChange)="selectType($event.value)"></p-dropdown>
      </div>
      <div class="col-6">
        <p-dropdown [options]="validationGroups" [(ngModel)]="selectedGroup"
          (onChange)="selectValidationGroup($event.value)"></p-dropdown>
      </div>
    </div>
  </div>
  <div class="row m-t-md m-b-lg">
    <div class="col-12">
      <p-treeTable [value]="groupedInfo">
        <ng-template pTemplate="header">
          <tr>
            <th class="col-4">{{ 'General.identifier' | translate }}</th>
            <th class="col-4"> {{ 'General.description' | translate }}</th>
            <th class="col-4"> {{ 'validations.validation' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-validation="rowData">
          <tr>
            <td>
              <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
              <i *ngIf="validation.severity === 'FATAL'" class="fas fa-1-5x fa-exclamation-circle text-danger"
                aria-hidden="true"></i>
              <i *ngIf="validation.severity === 'ERROR'" class="fas fa-1-5x fa-exclamation-triangle text-warning"
                aria-hidden="true"></i>
              <i *ngIf="validation.severity === 'WARNING'" class="fas fa-1-5x fa-info-circle text-info"
                aria-hidden="true"></i> &nbsp; <small class="text-break"> {{ validation.identifier }} </small>
            </td>
            <td class="text-break">{{ validation.description }}</td>
            <td>
              <div *ngIf="validation.path" class="text-break">
                <b>{{'validations.path' | translate}}:</b> {{ validation.path }}
              </div>
              <div *ngIf="validation.validationExecutor" class="text-break">
                <b>{{'validations.executor' | translate}}:</b> {{ validation.validationExecutor }}
              </div>
              <div *ngIf="validation.transformationProperty" class="text-break">
                <b>{{'validations.transformation' | translate}}:</b> {{ validation.transformationProperty }}
              </div>
              <div *ngIf="validation.precondition" class="text-break">
                <b>{{'validations.precondition' | translate}}:</b> {{ validation.precondition }}
              </div>
              <div *ngIf="validation.validation" class="text-break">
                <b>{{'validations.validation' | translate}}:</b> {{ validation.validation }}
              </div>
            </td>
          </tr>
        </ng-template>
      </p-treeTable>
    </div>
  </div>
</div>